import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const CreateContentIndexType = () => {
  const [contentIndexTypeCodes, setContentIndexTypeCodes] = useState([]);
	const token = globalConfig.hardcoded_header;
  const [message, setMessage] = useState("");
  const [state, setState] = useState({
    contentIndexTypeId: 0,
    contentIndexValueCode: 0,
    contentIndexTypeName: "",
    contentIndexTypeTitle: "",
    contentIndexTypeDescr: "",
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-index-types`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-index-types/contentIndexTypeId`;

    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentIndexTypeId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(
            response2.status + ":" + response2.data.contentIndexTypeId
          );
          // && response2.data.contentIndexTypeId === this.state.contentIndexTypeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      //     console.log(response.data)
      //          .catch(err => {
      //             console.log(err);
      //           });
      console.log("message info - " + message);
      setState({
        ...state,
        contentIndexTypeId: 0,
        contentIndexTypeTitle: " ",
        contentIndexTypeDescr: " ",
      });
    });
  }
  function handleRest(event) {
    setState({
      ...state,
      contentIndexTypeId: 0,
      contentIndexTypeTitle: " ",
      contentIndexTypeDescr: " ",
    });
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_INDEX_TYPE`,
         apiHeader(token)
      )
      .then((res) => {
        const contentIndexTypeCodes = res.data;
        console.log("results", contentIndexTypeCodes);
        setContentIndexTypeCodes(contentIndexTypeCodes);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });
  };
  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Index Type</h4>			
			<Link to="/breeze/list-content-index-types">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Index Type Name">
            Content Index Type Name
          </label>
          <input
            id="contentIndexTypeName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexTypeName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Index Type Title">
            Content Index Type Title
          </label>
          <input
            id="contentIndexTypeTitle"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexTypeTitle}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Index Value Code">
            Content Index Value Code
          </label>
          <select
            id="contentIndexValueCode"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexValueCode}
            onChange={handleChange}
          >
            {/* <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('CONTENT_INDEX_TYPE_CODE')}"/> */}
            <option value={0}>Select Index Value Type</option>
            {contentIndexTypeCodes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Index Type Description"
          >
            Content Index Type Description
          </label>
          <textarea
            id="contentIndexTypeDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexTypeDescr}
            onChange={handleChange}
          />
        </div>
        <hr />
        <button className="btn btn-primary" value="Clear" onClick={handleRest}>
          {" "}
          Clear
        </button>
        &nbsp;
        <button className="btn btn-success" value="Create" onClick={handleSubmit}>
          {" "}
          Create
        </button>
      </div>
    </form>
  );
};

export default CreateContentIndexType;
